import React from 'react';
import PropTypes from 'prop-types';
import Drawer from '../Common/Drawer/Drawer';
import Toggle from '../Common/Toggle/Toggle';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';
import './CustomizeWidgetsDrawer.scss';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';

import { CORPORATE_DASHBOARD_DEFAULT } from '../../constants/constants';
const { CORPORATE_DASHBOARD_VIEW_DEFAULT_ID } = CORPORATE_DASHBOARD_DEFAULT;

export class CustomizeWidgetsDrawer extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			isLoading: false,
			settings: props.settings,
			filters: props.filters
		};
	}

	applyFilters = () => {
		const updatedSettings = {
			...this.state.settings,
			updates: this.state.settings.updates + 1,
			id: CORPORATE_DASHBOARD_VIEW_DEFAULT_ID,
			name: undefined
		};

		this.props.onComplete(updatedSettings);
	};

	onFormChange = (name, value) => {
		this.setState({ settings: { ...this.state.settings, [name]: value } }, () => this.props.checkAvailability(this.state.settings));
	};

	onDropdownChange = (csv, name) => {
		if (csv === '') {
			this.setState({ settings: { ...this.state.settings, [name]: [] } }, () => this.props.checkAvailability(this.state.settings));
		} else {
			this.setState({ settings: { ...this.state.settings, [name]: csv.split(',') } }, () => this.props.checkAvailability(this.state.settings));
		}
	};

	onCancel = () => {
		this.props.onClose();
	};

	onClear = () => {
		// The update prop tells the widgets that use these that changes were made to increment it
		let newSettings = this.props.defaultSettings;
		newSettings.updates += 1;
		newSettings.id = CORPORATE_DASHBOARD_VIEW_DEFAULT_ID;
		newSettings.name = undefined;
		this.setState((prevState) => ({ 
			settings: { ...prevState.settings, ...newSettings }
		}));
	};

	render() {
		const customFooter = (
			<div className='button-wrap text-center'>
				<button type='button' className='btn btn-primary button--save' onClick={this.applyFilters}>
					Apply
				</button>
				<button type='button' className='btn btn-danger' onClick={this.onClear}>
					Clear
				</button>
				<button type='button' className='btn btn-secondary' onClick={this.onCancel}>
					Cancel
				</button>
			</div>
		);

		return (
			<Drawer
				isWide={false}
				title={this.props.settings.id ? 'Edit Filters' : 'Create a new view'}
				onSaveClick={this.props.onComplete}
				onCancelClick={this.props.onClose}
				customFooter={customFooter}>
				<LoadingIndicator isLoading={this.state.isLoading}>
					<div className='customize-widgets-drawer'>
						<div className='section-title'>Task Attribute Filters</div>
						<div>
							<Toggle
								name='isMilestonesOnly'
								text='Milestones Only'
								checked={this.state.settings.isMilestonesOnly}
								onChange={this.onFormChange}
							/>
							<MultiSelectBox
								name='disciplineIds'
								label='Disciplines'
								idField='id'
								valueField='name'
								options={this.props.filters.disciplines}
								selectedValues={this.state.settings.disciplineIds.toString()}
								onChange={this.onDropdownChange}
								isMulti={true}
							/>
							<MultiSelectBox
								name='departmentIds'
								label='Departments'
								idField='id'
								valueField='name'
								options={this.props.filters.departments}
								selectedValues={this.state.settings.departmentIds.toString()}
								onChange={this.onDropdownChange}
								isMulti={true}
							/>
							<MultiSelectBox
								name='phaseIds'
								label='Phases'
								idField='id'
								valueField='name'
								options={this.props.filters.phases}
								selectedValues={this.state.settings.phaseIds.toString()}
								onChange={this.onDropdownChange}
								isMulti={true}
							/>
							<MultiSelectBox
								name='communityIds'
								label='Communities'
								idField='id'
								valueField='name'
								options={this.props.filters.communities}
								selectedValues={this.state.settings.communityIds.toString()}
								onChange={this.onDropdownChange}
								isMulti={true}
							/>
							<MultiSelectBox
								name='baselineIds'
								label='Baselines'
								idField='id'
								valueField='name'
								options={this.props.filters.baselines}
								selectedValues={this.state.settings.baselineIds.toString()}
								onChange={this.onDropdownChange}
								isMulti={true}
							/>
							<MultiSelectBox
								name='projectIds'
								label='Projects'
								idField='id'
								valueField='name'
								options={this.props.filters.projects}
								selectedValues={this.state.settings.projectIds.toString()}
								onChange={this.onDropdownChange}
								isMulti={true}
							/>
							<MultiSelectBox
								name='locationIds'
								label='Locations'
								idField='id'
								valueField='name'
								options={this.props.filters.locations}
								selectedValues={this.state.settings.locationIds.toString()}
								onChange={this.onDropdownChange}
								isMulti={true}
							/>
						</div>
						<div className='section-title'>Team/Location Filters</div>
						<div>
							<MultiSelectBox
								name='brandIds'
								label='Brands'
								idField='id'
								valueField='name'
								options={this.props.filters.brands}
								selectedValues={this.state.settings.brandIds.toString()}
								onChange={this.onDropdownChange}
								isMulti={true}
							/>
							<MultiSelectBox
								name='areaIds'
								label='Areas'
								idField='id'
								valueField='name'
								options={this.props.filters.areas}
								selectedValues={this.state.settings.areaIds.toString()}
								onChange={this.onDropdownChange}
								isMulti={true}
							/>
							<MultiSelectBox
								name='regionIds'
								label='Regions'
								idField='id'
								valueField='name'
								options={this.props.filters.regions}
								selectedValues={this.state.settings.regionIds.toString()}
								onChange={this.onDropdownChange}
								isMulti={true}
							/>
							<MultiSelectBox
								name='managementCompanyIds'
								label='Managment Companies'
								idField='id'
								valueField='name'
								options={this.props.filters.managementCompanies}
								selectedValues={this.state.settings.managementCompanyIds.toString()}
								onChange={this.onDropdownChange}
								isMulti={true}
							/>
							<MultiSelectBox
								name='locationTypeIds'
								label='Location Types'
								idField='id'
								valueField='name'
								options={this.props.filters.locationTypes}
								selectedValues={this.state.settings.locationTypeIds.toString()}
								onChange={this.onDropdownChange}
								isMulti={true}
							/>
							<MultiSelectBox
								name='continentIds'
								label='Continents'
								idField='id'
								valueField='name'
								options={this.props.filters.continents}
								selectedValues={this.state.settings.continentIds.toString()}
								onChange={this.onDropdownChange}
								isMulti={true}
							/>
							<MultiSelectBox
								name='tagIds'
								label='Tags'
								idField='id'
								valueField='name'
								options={this.props.filters.tags}
								selectedValues={this.state.settings.tagIds.toString()}
								onChange={this.onDropdownChange}
								isMulti={true}
							/>
						</div>
						<div className='section-title'>Widget Toggles</div>
						<div>
							{this.props.isSubscriptionProjectWidgetActive && (
								<Toggle
									name='isProjectSummariesActive'
									text='Project Summaries'
									checked={this.state.settings.isProjectSummariesActive}
									onChange={this.onFormChange}
								/>
							)}
							<Toggle
								name='isLocationSummariesActive'
								text='Location Summaries'
								checked={this.state.settings.isLocationSummariesActive}
								onChange={this.onFormChange}
							/>
							<Toggle
								name='isMyTasksDueSoonActive'
								text='My Tasks Due Soon'
								checked={this.state.settings.isMyTasksDueSoonActive}
								onChange={this.onFormChange}
							/>
							<Toggle
								name='isMilestonesMissedActive'
								text='Milestones Missed'
								checked={this.state.settings.isMilestonesMissedActive}
								onChange={this.onFormChange}
							/>
						</div>

						{ this.props.matchingSettings.length > 0 &&
							<div className="alert alert-warning">
								<p>There is already {this.props.matchingSettings.length} view(s) with the same filters.</p>
								<ol>
									{ this.props.matchingSettings.map(setting => <li key={setting.id}>{setting.name}</li>) }
								</ol>
							</div>
						}
					</div>
				</LoadingIndicator>
			</Drawer>
		);
	}
}

CustomizeWidgetsDrawer.propTypes = {
	onComplete: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
	settings: PropTypes.object.isRequired,
	defaultSettings: PropTypes.object.isRequired,
	filters: PropTypes.object.isRequired,
	isSubscriptionProjectWidgetActive: PropTypes.bool.isRequired,
	matchingSettings: PropTypes.array.isRequired,
	checkAvailability: PropTypes.func.isRequired
};

export default CustomizeWidgetsDrawer;
